import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";
import { Eye, Unlock, Fingerprint, Scale, Globe2, ArrowRight } from "lucide-react";

const PRINCIPLES = [
  { k: "p1", icon: Unlock, color: "#00FF7F" },
  { k: "p2", icon: Fingerprint, color: "#00FFFF" },
  { k: "p3", icon: Scale, color: "#F59E0B" },
  { k: "p4", icon: Globe2, color: "#8A2BE2" },
];

export const JusticeFramework = () => {
  const { t } = useLang();
  return (
    <section id="justice-framework" className="relative overflow-hidden" data-testid="justice-framework-section">
      <div className="absolute inset-0 bg-[#070C1C]" />
      <div className="absolute inset-0 qs-noise opacity-40" />
      <div className="relative mx-auto max-w-7xl px-6 py-24">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 text-[#8A2BE2] text-xs font-mono uppercase tracking-widest">
              <Eye className="h-4 w-4" /> {t("jf_tag")}
            </span>
            <h2 className="font-display font-bold text-2xl md:text-4xl tracking-tight mt-4 leading-tight" data-testid="jf-title">
              <span className="qs-grad-text">{t("jf_title")}</span>
            </h2>
            <p className="text-slate-400 mt-5 max-w-2xl leading-relaxed">{t("jf_sub")}</p>
            <Link to="/justice" data-testid="jf-open-btn"
              className="qs-cta inline-flex items-center gap-2 mt-8 px-6 py-3 bg-[#8A2BE2] text-white font-semibold">
              {t("jf_cta")} <ArrowRight className="h-4 w-4" />
            </Link>
            <p className="text-[11px] font-mono text-slate-600 mt-4">{t("jf_note")}</p>
          </div>
          <div className="lg:col-span-5 grid sm:grid-cols-2 gap-3 content-start">
            {PRINCIPLES.map((p, i) => (
              <motion.div key={p.k} initial={{ opacity: 0, x: 16 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.45, delay: i * 0.1 }} className="qs-panel qs-lift p-5" data-testid={`jf-principle-${p.k}`}>
                <p.icon className="h-5 w-5" style={{ color: p.color }} />
                <h4 className="font-display font-semibold mt-3">{t(`jf_${p.k}`)}</h4>
                <p className="text-xs text-slate-500 mt-1.5 leading-relaxed">{t(`jf_${p.k}_d`)}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
